import { CapoPlugin } from "/home/debian/projects/my-website/node_modules/.pnpm/@unhead+vue@1.9.16_vue@3.5.34/node_modules/@unhead/vue/dist/index.mjs";
export default import.meta.server ? [CapoPlugin({ track: true })] : [];